import { ViewChild, Component, Renderer, Input } from '@angular/core';

import { DataService } from '../../../../services/data';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/mergeMap';
import { Rodeo } from '../../../../model/rodeo';

import { AlertMessager } from '../../../../lib/alertMessager';
import { Account } from '../../../../model/account';
import { ModalController, LoadingController } from 'ionic-angular';
import { NewMemberPage } from './new-member';
import { Organization } from '../../../../model/organization';
import { AccountMembership } from '../../../../model/accountMembership';
import { RodeoService } from '../../../../services/rodeo.service';

@Component({
    selector: 'staff-memberships',
    templateUrl: 'memberships.html'
})
export class MembershipsSection {
    @ViewChild('userSearch') userSearch;

    _rodeo: Rodeo;
    _viewMode: string = 'users';
    memberFile: any;
    
    searchChangeObservable;
    userResults: any = [];
    firstName: string;
    lastName: string;
    membershipId: string;

    _organizations: Organization[] = [];

    @Input()
    set rodeo(rodeo: Rodeo) {
        if (rodeo != null) {
            this._rodeo = rodeo;
        }
    }
    get rodeo(): Rodeo {
        return this._rodeo;
    }

    @Input()
    set viewMode(viewMode: string) {
        if (viewMode != null) {
            this._viewMode = viewMode;
        }
    }
    get viewMode(): string {
        return this._viewMode;
    }

    @Input()
    set organizations(organizations: Organization[]) {
        if (organizations != null) {
            this._organizations = organizations;
        }
    }
    get organizations(): Organization[] {
        return this._organizations;
    }

    popoverActive: boolean;
    loadingData: boolean;

    constructor(private dataService: DataService, private alert: AlertMessager, private loadingController: LoadingController, 
        private modalCtrl: ModalController, private rodeoService: RodeoService) {
    }

    onFirstNameSearchChange(searchValue: string) {
        this.onSearchChange('firstName' + searchValue);
    }

    onLastNameSearchChange(searchValue: string) {
        this.onSearchChange('lastName' + searchValue);
    }

    onMembershipIdSearchChange(searchValue: string) {
        this.onSearchChange('membershipId' + searchValue);
    }

    onSearchChange(searchValue : string) {
        if (!this.searchChangeObservable) {
            Observable.create(observer => {
                this.searchChangeObservable = observer;
            }).debounceTime(300) // wait 300ms after the last event before emitting last event
              .distinctUntilChanged() // only emit if value is different from previous value
              .subscribe(() => { this.searchForAccount() });
        }

		this.searchChangeObservable.next(searchValue);
    }

	async searchForAccount() {
        this.loadingData = true;
        this.userResults = await this.dataService.getStaffUserSearch(this.firstName, this.lastName, this.membershipId);
        this.loadingData = false;
    }
    
    getSearchMessage() {
        if (this.loadingData)
            return "";

        if (!this.firstName && !this.lastName && !this.membershipId)
            return "";
        else if (this.userResults == undefined || this.userResults.length < 1)
            return "There are no users by that name.";

        return "";
    }

    changeListener($event) : void {
        this.memberFile = $event.target.files[0];
    }

    uploadMembers() {
        if (this.popoverActive)
            return;

        let loader = this.loadingController.create({
            content: 'Uploading members...',
        });

        loader.present();
        this.popoverActive = true;
        this.rodeoService.uploadMembers(this.memberFile, this._rodeo.organization.id)
        .then(data => {
            loader.dismiss();
            this.popoverActive = false;
            console.log("data: ", data);
        }, error => {
            loader.dismiss();
            this.popoverActive = false;
            console.log("upload error: ", error)
        });
    }

    addUser() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let entryModal = this.modalCtrl.create(NewMemberPage, { account: null, organizations: this.organizations }, { cssClass: 'page-new-member', enableBackdropDismiss: true });

        entryModal.present();
        entryModal.onDidDismiss((data) =>{
            this.popoverActive = false;

            console.log("member: ", data);
        });
    }
    
    editUser(account: Account) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let entryModal = this.modalCtrl.create(NewMemberPage, { account: account, organizations: this.organizations }, { cssClass: 'page-new-member', enableBackdropDismiss: true });

        entryModal.present();
        entryModal.onDidDismiss((data) =>{
            this.popoverActive = false;

            console.log("member: ", data);
        });
    }

    getOrgName(orgId: number) {
        const org = this.organizations.find(x => x.id === orgId);
        if (org) {
            return org.name;
        } else {
            console.error(`Organization with id ${orgId} not found.`);
            return null;
        }
    }

    formatMemberships(memberships: AccountMembership[]) {
        if (!memberships || memberships.length == 0) {
            return "None";
        } else {
            return memberships.flatMap(membership => membership.id + ' (' + this.getOrgName(membership.membership.organizationId) + ')').join(', ');
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/memberships/memberships.ts